import axios from 'axios';
import { log } from './logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ---------- Visitor + session ids ----------
const VID_KEY = 'ukk_visitor_id';
const SID_KEY = 'ukk_session_id_analytics';

function uuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'v-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
}

export function getVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = uuid();
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch (e) {
    log.warn('Visitor ID storage unavailable', e);
    return 'anon';
  }
}

export function getAnalyticsSessionId() {
  try {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) {
      s = uuid();
      sessionStorage.setItem(SID_KEY, s);
    }
    return s;
  } catch (e) {
    log.warn('Session ID storage unavailable', e);
    return 'anon';
  }
}

// ---------- Event logger ----------
export function trackEvent(event, meta = {}) {
  try {
    const payload = {
      event,
      visitor_id: getVisitorId(),
      session_id: getAnalyticsSessionId(),
      path: (typeof window !== 'undefined' && window.location) ? window.location.pathname : '/',
      referrer: (typeof document !== 'undefined' ? document.referrer : '') || '',
      user_agent: (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '',
      meta: meta || {},
      source: meta && meta.source ? meta.source : '',
    };
    // Fire-and-forget; don't block UI on failure but log for debugging
    axios.post(`${API}/analytics/event`, payload).catch((err) => {
      log.warn('Analytics event failed:', event, err?.message || err);
    });
  } catch (e) {
    log.warn('trackEvent threw synchronously:', e);
  }
}

// Track initial page view + auto-hook for tel:/sms: links
let _pvOnce = false;
export function initAnalytics() {
  if (typeof window === 'undefined') return;
  if (_pvOnce) return;
  _pvOnce = true;
  // Wait for the page to be minimally interactive
  const send = () => trackEvent('page_view', { title: document.title });
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(send, 200);
  } else {
    window.addEventListener('load', send, { once: true });
  }

  // Global tel: / sms: capture (so we never miss a call/text)
  document.addEventListener(
    'click',
    (e) => {
      const a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      const href = a.getAttribute('href') || '';
      if (href.startsWith('tel:')) {
        trackEvent('phone_click', { href, source: a.getAttribute('data-testid') || 'anonymous-tel' });
      } else if (href.startsWith('sms:')) {
        trackEvent('text_click', { href, source: a.getAttribute('data-testid') || 'anonymous-sms' });
      }
    },
    { capture: true },
  );
}
